import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * NOC, council side.
 *
 * NOCs are issued automatically the moment payment is verified, so the council
 * no longer approves them by hand - the list is a record. The council does,
 * however, own the NOC Types master: the kinds of NOC on offer and their fees.
 */

const adminToken = () => localStorage.getItem("adminToken");

/* ----------------------------- NOC record ----------------------------- */

/** Every NOC applied for, newest first, with the issued certificate link. */
export const getNocList = (params = {}) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    ["status", "search", "page", "per_page"].forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== "" && value !== "all") {
        q.append(key, value);
      }
    });
    const suffix = q.toString() ? `?${q.toString()}` : "";
    const response = await dispatch(
      getDataAPI(`admin/noc/list${suffix}`, adminToken())
    );
    return response ? response.data : false;
  } catch (error) {
    return false;
  }
};

/* --------------------------- NOC Types master --------------------------- */

export const getNocTypes = () => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI("admin/noc-type/list", adminToken())
    );
    return response.data.data || [];
  } catch (error) {
    return [];
  }
};

export const saveNocType = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/noc-type/save", data, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be saved.");
    return false;
  }
};

export const deleteNocType = (id) => async (dispatch) => {
  try {
    const body = new FormData();
    body.append("id", id);
    const response = await dispatch(
      postDataAPI("admin/noc-type/delete", body, adminToken())
    );
    successAlert(response.data.message);
    return true;
  } catch (error) {
    errorAlert(error.response?.data?.message || "That could not be deleted.");
    return false;
  }
};
